<script>
  import { ttsPlayback, setTTSEnabled } from '../state/settings.svelte.js';
  import { stopSpeaking } from '../utils/tts-audio.js';

  let { retry = null } = $props();
  let retrying = $state(false);

  async function retryAudio() {
    retrying = true;
    ttsPlayback.error = null;
    try {
      await retry();
    } catch {
      ttsPlayback.error = 'Audio guidance could not load. You can keep typing, retry audio, or mute it.';
    } finally {
      retrying = false;
    }
  }

  function mute() {
    stopSpeaking();
    setTTSEnabled(false);
    ttsPlayback.error = null;
  }
</script>

{#if ttsPlayback.error}
  <div class="voice-notice" role="status">
    <p>{ttsPlayback.error}</p>
    {#if retry}
      <button class="btn-secondary" onclick={retryAudio} disabled={retrying}>
        {retrying ? 'Loading audio…' : 'Retry audio'}
      </button>
    {/if}
    <button class="btn-secondary" onclick={mute}>Mute audio</button>
  </div>
{/if}

<style>
  .voice-notice {
    margin-bottom: 1rem;
    padding: 0.75rem;
    border: 1px solid var(--color-border);
    border-radius: 8px;
    background: var(--color-surface);
  }
  p { margin: 0 0 0.5rem; }
  button { min-height: 44px; margin-right: 0.5rem; }
</style>
